<p class="example-address">
	exampl: <input value="0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c" readonly>
			<i on:click={copyToClipBoard} class="material-icons">content_copy</i>
			<br>
	( WBNB contract )
</p>

<style>
	.example-address {
		margin: .5rem 0;
	}
	.example-address > input {
		width: 385px;
		border: 0;
	}
	.example-address > i.material-icons {
		font-size: 20px;
		vertical-align: middle;
		cursor: pointer;
	}
	:global(.example-address > i.material-icons.copied::after) {
		font-family: 'Orbitron';
		color: #e84757;
		content: "copied!";
		padding: 7.5px;
		border-radius: 4px;
		background-color: #fff;
		position: absolute;
		font-size: small;
	}
	@media (max-width: 480px) {
		.example-address {
			overflow-x: hidden;
		}
	}
</style>

<script>
	const d = document;

	function copyToClipBoard(e){
		e.target.previousElementSibling.select();
		d.execCommand("Copy");
		e.target.classList.add("copied");
		setTimeout(()=>{
			e.target.classList.remove("copied");
		},1500);
	}
</script>